import { useQuery } from "@tanstack/react-query";
import { applicationsApi, ApplicationDecision } from "api/applications";

export const useApplicationDecision = (
  applicationId: string | number | undefined,
  options?: { enabled?: boolean; staleTime?: number }
) =>
  useQuery<ApplicationDecision>({
    queryKey: ["APPLICATION", String(applicationId), "decision"],
    queryFn: () =>
      applicationsApi.getApplicationDecision(String(applicationId)),
    enabled: !!applicationId && (options?.enabled ?? true),
    staleTime: options?.staleTime
  });
